<div class="col-12 col-md-10 p-0 mb-3" [ngClass]="className">
    <div #captchaContainer></div>
</div>
